(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  // const open_cart_drawer = document.querySelector(".open-cart-drawer");
  // const close_cart_drawer = document.querySelector(".close-cart-drawer");

  // document.addEventListener('DOMContentLoaded', ()=>{
  //     document.querySelector(".open-cart-drawer").addEventListener('click', openCart)

  //     document.querySelector(".close-cart-drawer").addEventListener('click', closeCart)

  //     document.querySelector(".cart-drawer-container").addEventListener('click', (e) => {
  //         if (e.target === e.currentTarget) {
  //             openCart()
  //         }
  //     });
  // })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const footer = document.querySelector('footer');
    const footerContainer = document.querySelector('.footer-container');
    const head = document.querySelector('.footer-head');

    if (footerContainer && footer) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              footer.classList.add('in-view');
            } else {
              footer.classList.remove('in-view');
            }
          });
        },
        {
          threshold: 0.2,
        },
      );

      observer.observe(footerContainer);
    }

    if (head && footer) {
      const threshold = 150;
      const maxMove = 15;

      document.addEventListener('mousemove', (e) => {
        if (!footer.classList.contains('in-view')) return;

        const rect = head.getBoundingClientRect();
        const headX = rect.left + rect.width / 2;
        const headY = rect.top + rect.height / 2;

        const dist = Math.hypot(e.clientX - headX, e.clientY - headY);

        if (dist < threshold) {
          const pullX = ((e.clientX - headX) / threshold) * maxMove;
          const pullY = ((e.clientY - headY) / threshold) * maxMove;

          head.style.setProperty('--mag-x', `${pullX}px`);
          head.style.setProperty('--mag-y', `${pullY}px`);
          head.classList.add('magnetic-active');
        } else {
          head.style.setProperty('--mag-x', `0px`);
          head.style.setProperty('--mag-y', `0px`);
          head.classList.remove('magnetic-active');
        }
      });

      head.addEventListener('click', () => {
        head.classList.add('shake');
        setTimeout(() => {
          head.classList.remove('shake');
        }, 500);
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-about"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const vectorContainer = document.querySelector('.about-hero-vector');
    const vectorSvg = document.querySelector('.about-hero-vector svg');
    if (vectorSvg && vectorContainer) {
      vectorSvg.style.transition = 'transform 0.4s ease';

      window.addEventListener('scroll', function () {
        if (window.scrollY > 50) {
          vectorSvg.style.transform = 'scale(0.25)';
          vectorContainer.classList.add('is-sticky');
        } else {
          vectorSvg.style.transform = 'scale(1)';
          vectorContainer.classList.remove('is-sticky');
        }

        if (window.scrollY > 185) {
          vectorContainer.style.background =
            'linear-gradient(to bottom, var(--background-primary) 10%, transparent 100%)';
          vectorContainer.style.paddingBottom = '20px';
        } else {
          vectorContainer.style.background = 'none';
          vectorContainer.style.paddingBottom = '0px';
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-dairy"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const section = document.getElementById('diary-detail-section');
    window.addEventListener('scroll', () => {
      if (window.scrollY > 100) {
        section.classList.add('is-scrolled');
      } else {
        section.classList.remove('is-scrolled');
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-size-guide"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const modal = document.getElementById('sister-modal');
    if (!modal) return;

    const triggers = document.querySelectorAll('.sister-modal-trigger');
    const closeBtn = modal.querySelector('.sister-modal-close');
    const overlay = modal.querySelector('.sister-modal-overlay');

    const modalImage = modal.querySelector('.sister-modal-image');
    const modalTitle = modal.querySelector('.sister-modal-title');
    const modalDescription = modal.querySelector('.sister-modal-description');
    const modalProducts = modal.querySelector('.sister-modal-products');

    triggers.forEach((trigger) => {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        const title = this.getAttribute('data-title');
        const description = this.getAttribute('data-description');
        const image = this.getAttribute('data-image');

        const sisterItem = this.closest('.sister-item');
        const productsData = sisterItem.querySelector('.sister-products-data');

        if (modalTitle) modalTitle.textContent = title;
        if (modalDescription) modalDescription.innerHTML = description;
        if (modalImage) {
          modalImage.src = image;
          modalImage.alt = title;
        }

        if (modalProducts && productsData) {
          modalProducts.innerHTML = productsData.innerHTML;
        } else if (modalProducts) {
          modalProducts.innerHTML = '';
        }

        modal.classList.add('active');
        document.body.classList.add('overflow-hidden');
        document.body.style.overflow = 'hidden';
      });
    });

    const closeModal = () => {
      modal.classList.remove('active');
      document.body.classList.remove('overflow-hidden');
      document.body.style.overflow = '';
    };

    if (closeBtn) closeBtn.addEventListener('click', closeModal);
    if (overlay) overlay.addEventListener('click', closeModal);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('active')) {
        closeModal();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password"]) return;
  try {
    
  const showPasswordBtn = document.querySelector('#show_password_section');
  const showNewsletterBtn = document.querySelector('#show_password_newsletter_section');

  showPasswordBtn.addEventListener('click', () => {
    document.querySelector('#password_container').classList.remove('hidden');
    document.querySelector('#password_newsletter_container').classList.add('hidden');
    showPasswordBtn.setAttribute('aria-expanded', 'true');
    showNewsletterBtn.setAttribute('aria-expanded', 'false');
  });

  showNewsletterBtn.addEventListener('click', () => {
    document.querySelector('#password_container').classList.add('hidden');
    document.querySelector('#password_newsletter_container').classList.remove('hidden');
    showNewsletterBtn.setAttribute('aria-expanded', 'true');
    showPasswordBtn.setAttribute('aria-expanded', 'false');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["products-reccomendation"]) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }
      })
      .catch((e) => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, { rootMargin: '0px 0px 200px 0px' });

  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ring-text"]) return;
  try {
    
  const TEXT = 'MEJIMEJI MINISTRY • MEJIMEJI MINSTRY • ';
  const SPACING = 1.1; // character width (ch)
  const SIZE = 0.6; // font-size (rem)

  const canTrig = CSS.supports('(top: calc(sin(1) * 1px))');
  const HEADING = document.getElementById('ring');

  function buildRing(text) {
    // Clear any existing chars
    HEADING.innerHTML = '';

    // Create one span per character
    [...text].forEach((char, index) => {
      const span = document.createElement('span');
      span.className = 'char';
      span.textContent = char;
      span.style.setProperty('--char-index', index);
      HEADING.appendChild(span);
    });

    // Update CSS custom properties based on new content
    const count = HEADING.children.length;
    const innerAngle = `calc((360 / var(--char-count, ${count})) * 1deg)`;

    let radiusExpr;
    if (canTrig) {
      radiusExpr = `calc((var(--character-width, ${SPACING.toFixed(1)}) / sin(var(--inner-angle))) * -1ch)`;
    } else {
      const angleRad = 360 / count / (180 / Math.PI);
      radiusExpr = `calc((var(--character-width, ${SPACING.toFixed(1)}) / ${Math.sin(angleRad)}) * -1ch)`;
    }

    HEADING.style.setProperty('--char-count', count);
    HEADING.style.setProperty('--inner-angle', innerAngle);
    HEADING.style.setProperty('--character-width', SPACING.toFixed(1));
    HEADING.style.setProperty('--radius', radiusExpr);
    HEADING.style.setProperty('--font-size', SIZE.toFixed(1));
  }

  buildRing(TEXT);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sisters-gallery"] && !Shopify.designMode) return;
  try {
    
  function initSisterVideosObserver() {
    const videos = document.querySelectorAll('.sisters-gallery-scroll .sister-video');
    if (!videos.length) return;

    if ('IntersectionObserver' in window) {
      const videoObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const vid = entry.target;
            if (entry.isIntersecting) {
              const playPromise = vid.play();
              if (playPromise !== undefined) {
                playPromise.catch(() => {});
              }
            } else {
              vid.pause();
            }
          });
        },
        { threshold: 0.1 }
      );

      videos.forEach((vid) => videoObserver.observe(vid));
    }
  }

  function initSisterModal() {
    if (window.__sisterModalInitialized) return;
    window.__sisterModalInitialized = true;

    initSisterVideosObserver();

    document.addEventListener('click', function (e) {
      const trigger = e.target.closest('.sister-modal-trigger');
      if (!trigger) return;

      e.preventDefault();
      e.stopPropagation();

      const modal = document.getElementById('sister-modal');
      if (!modal) return;

      const title = trigger.getAttribute('data-title') || '';
      const description = trigger.getAttribute('data-description') || '';
      const image = trigger.getAttribute('data-image') || '';
      const mediaType = trigger.getAttribute('data-media-type') || 'image';
      const videoSrc = trigger.getAttribute('data-video-src') || '';

      const sisterItem = trigger.closest('.sister-item');
      const productsData = sisterItem ? sisterItem.querySelector('.sister-products-data') : null;

      const modalImage = modal.querySelector('.sister-modal-image');
      const modalVideo = modal.querySelector('.sister-modal-video');
      const modalTitle = modal.querySelector('.sister-modal-title');
      const modalDescription = modal.querySelector('.sister-modal-description');
      const modalProducts = modal.querySelector('.sister-modal-products');

      if (modalTitle) modalTitle.textContent = title;
      if (modalDescription) modalDescription.innerHTML = description;

      if (mediaType === 'video' && videoSrc) {
        if (modalImage) modalImage.style.display = 'none';
        if (modalVideo) {
          modalVideo.style.display = 'block';
          modalVideo.poster = image;
          if (modalVideo.src !== videoSrc) {
            modalVideo.src = videoSrc;
          }
          const playPromise = modalVideo.play();
          if (playPromise !== undefined) {
            playPromise.catch(() => {});
          }
        }
      } else {
        if (modalVideo) {
          modalVideo.pause();
          modalVideo.style.display = 'none';
          modalVideo.removeAttribute('src');
          modalVideo.load();
        }
        if (modalImage) {
          modalImage.style.display = 'block';
          modalImage.src = image;
          modalImage.alt = title;
        }
      }

      if (modalProducts) {
        if (productsData) {
          modalProducts.innerHTML = productsData.innerHTML;
        } else {
          modalProducts.innerHTML = '';
        }
      }

      modal.classList.add('active');
      document.body.classList.add('overflow-hidden');
      document.body.style.overflow = 'hidden';
    });

    const closeModal = () => {
      const modal = document.getElementById('sister-modal');
      if (modal) {
        modal.classList.remove('active');
        const modalVideo = modal.querySelector('.sister-modal-video');
        if (modalVideo) {
          modalVideo.pause();
          modalVideo.removeAttribute('src');
          modalVideo.load();
        }
      }
      document.body.classList.remove('overflow-hidden');
      document.body.style.overflow = '';
    };

    document.addEventListener('click', function (e) {
      if (e.target.closest('.sister-modal-close') || e.target.classList.contains('sister-modal-overlay')) {
        e.preventDefault();
        closeModal();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        closeModal();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSisterModal);
  } else {
    initSisterModal();
  }

  } catch(e) { console.error(e); }
})();
})();
